import { render, staticRenderFns } from "./app-features.vue?vue&type=template&id=4f98c213&scoped=true&"
import script from "./app-features.vue?vue&type=script&lang=js&"
export * from "./app-features.vue?vue&type=script&lang=js&"
import style0 from "./app-features.vue?vue&type=style&index=0&id=4f98c213&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f98c213",
  null
  
)

export default component.exports